import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';

const CompositionAdvancedOptionsContext = createContext();

export const CompositionAdvancedOptionsContextProvider = ({ children }) => {
    const [limit, setLimit] = useState(12); // 12 || 24 || 48
    const [localLimit, setLocalLimit] = useState(12);
    const [nextKey, setNextKey] = useState("");
    const [prevKey, setPrevKey] = useState("");
    const [viewType, setViewType] = useState('browse'); // browse || structure
    const [page, setPage] = useState(1); // 1-based
    const [operator, setOperator] = useState('&&'); // also can be '||'
    const [query, setQuery] = useState({});
    const [localQuery, setLocalQuery] = useState({});
    const [sortBy, setSortBy] = useState('');
    const [reverse, setReverse] = useState(false);
    const [localReverse, setLocalReverse] = useState(false);
    const [primaryIndexName, setPrimaryIndexName] = useState('');
    const [firstPageMax, setFirstPageMax] = useState(null);
    const resetFilters = () => {
        setOperator('&&');
        setQuery({});
        setSortBy('');
        setPage(1);
        setReverse(false);
        setPrimaryIndexName('');
        setFirstPageMax(null);
    };

    const { selectedComposition } = useCompositionsContext();

    useEffect(() => {
        // Reset filters when composition changes
        resetFilters();
    }, [selectedComposition?.name]);

    useEffect(() => {
        setPrimaryIndexName('');
        setFirstPageMax(null);
    }, [selectedComposition?.structure?.indexes]);

    // Ensure pagination resets when scope changes
    useEffect(() => {
        setPage(1);
    }, [selectedComposition?.selected_scope]);

    const valueToShare = useMemo(() => ({
        operator,
        setOperator,
        query,
        setQuery,
        localQuery,
        setLocalQuery,
        resetFilters,
        limit,
        setLimit,
        localLimit,
        setLocalLimit,
        nextKey,
        setNextKey,
        prevKey,
        setPrevKey,
        sortBy,
        setSortBy,
        reverse,
        setReverse,
        localReverse,
        setLocalReverse,
        viewType,
        setViewType,
        page,
        setPage,
        primaryIndexName,
        setPrimaryIndexName,
        firstPageMax,
        setFirstPageMax
    }), [operator, query, localQuery, sortBy, limit, viewType, page, reverse, localLimit, nextKey, prevKey, localReverse, primaryIndexName, firstPageMax]);

    return (
        <CompositionAdvancedOptionsContext.Provider value={valueToShare}>
            {children}
        </CompositionAdvancedOptionsContext.Provider>
    )
}

export const useCompositionAdvancedOptionsContext = () => useContext(CompositionAdvancedOptionsContext);